import { connect } from 'react-redux';
import { goBack, push } from 'redux-first-history';
import HowToSetupPaymentPlan from './component';
import { closeNotification, showModalNotification } from '@common/actions/NotificationActions';
import { getRentalProtectionDisclaimers, requestMarkAcknowledged } from '@rental-manager/actions/requests';
import { checkRequestActionSuccess } from '@common/paymentsUtils/api';
import { DEFAULT_ERROR } from '@rental-manager/constants/NotificationConstants';
import paths from '@rental-manager/pathsManifest';
import DismissibleActionConstants from '@common/constants/DismissibleActionConstants';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state, { propertyId }) => {
  const { dismissibleActions, listingAlias } = state.payments.landlord.property;
  const { rentalProtectionDisclaimers } = state.payments.landlord.onboarding[propertyId];
  return {
    rentalProtectionDisclaimers,
    actionId: dismissibleActions[DismissibleActionConstants.PAYMENT_PLAN_INSTRUCTIONS],
    listingAlias,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl, propertyId }): Record<string, any> => ({
  getRentalProtectionDisclaimers: (listingAlias) =>
    Promise.resolve().then(() => dispatch(getRentalProtectionDisclaimers({ propertyId, listingAlias }))),
  onBack: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(goBack())),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(push(baseUrl))),
  acknowledgePaymentPlan: async (actionId) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(requestMarkAcknowledged({ propertyId, actionId })))
      .then(checkRequestActionSuccess)
      .then(() => dispatch(push(baseUrl + paths.dashboard.PaymentPlanInstallmentRequests)))
      .catch((err) => {
        logError({ error: err });
        dispatch(showModalNotification(DEFAULT_ERROR));
        return { error: true };
      }),
});

const mergeProps = (stateProps, dispatchProps) => {
  const { actionId } = stateProps;
  return {
    ...stateProps,
    ...dispatchProps,
    acknowledgePaymentPlan: () => dispatchProps.acknowledgePaymentPlan(actionId),
    getRentalProtectionDisclaimers: () => getRentalProtectionDisclaimers(stateProps.listingAlias),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(HowToSetupPaymentPlan);
